export default __webpack_public_path__ + "ba23e3df780e82476240e80c32122bd9.png";